import type {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../_ovlclient/src/library/table/tableapi"

export type UserAdministration_UserType = {
  CntctCode?: number
  FirstName: string
  LastName: string
  E_MailL: string
  CardCode: string
  U_ITFPrtUserId: string
  Active?: string
}

let columns: { [key in keyof UserAdministration_UserType]: SYSColumnDef } = {
  FirstName: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColFirstName" },
  },
  LastName: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColLastName" },
  },
  E_MailL: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColEmail" },
  },
  U_ITFPrtUserId: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColUserId" },
  },
  CardCode: {
    ui: { labelTranslationKey: "SYSUserAdministrationColCardName" },
    sortable: true,
    filter: { columnFilter: { type: "none" } },
    list: {
      displayField: "CardName",
      valueField: "CardCode",
      displayValueField: true,

      showCachedHitsWhileTyping: true,
      serverEndpoint: "useradministration/lookups/cardcode",
    },
    schema: { nullable: false },
  },
  Active: {
    control: "checkbox",
    ui: {
      checkedValue: "Y",
      labelTranslationKey: "SYSUserAdministrationColUserActive",
    },
  },
}

export let tblUserAdministration_UserRoleTransfer: SYSTableDef = {
  id: "SYSUserAdministration_UserRoleTransfer",
  permission: "SYSUA",
  feature: "SYSUserAdministration",
  database: {
    dataIdField: "CntctCode",
    dbInsertMode: "AutoIdentity",
  },
  server: {
    endpoint: "useradministration/user",
  },

  options: {
    initial_sort: { field: "FirstName", direction: "asc" },
    initial_paging: { page: 0, pageSize: 200 },
    initial_filterCustom: {
      ovld: {
        filters: {
          ValidUsers: {
            showInTitle: false,
            active: true,
          },
        },
      },
    },
  },

  features: {
    focusToFirstEditableField: true,
    filter: true,
    multiSelect: true,
  },
  columns,
}
